// extracted by mini-css-extract-plugin
module.exports = {"FullName":"UserMenu_FullName__12Wk7"};